import React from 'react';

import MainWrapper from 'shared/components/layout/MainWrapper/MainWrapper';
import { useBreakpoints } from 'shared/hooks';
import ClinicalDecisionSupportPage from './ClinicalDecisionSupportPage';

const ClinicalDecisionSupport = () => {
  const { smDown } = useBreakpoints();

  return (
    <MainWrapper sm={smDown}>
      <ClinicalDecisionSupportPage />
    </MainWrapper>
  );
};

export default ClinicalDecisionSupport;
